import React from 'react';
import DesktopMenuItem from './DesktopMenuItem';
import { FormattedMessage, injectIntl } from 'react-intl';
import './DesktopMenu.css';

export interface IDesktopMenuProps {
  changePage: (page: string) => void;
  intl: any;
}

const DesktopMenu = (props: IDesktopMenuProps) => {

  return(
    <div>
      <h1>
        <FormattedMessage id="home.frontpage"/>
      </h1>
      <div className="Menu-Container">
       <div className="d-flex flex-row flex-wrap button-wrap">
         <DesktopMenuItem text='desktop.receivereports' img="file-export" clickMe={() => props.changePage('receptionreports.browse') }/>
         <DesktopMenuItem text='desktop.handlerreports' img="file-import" clickMe={() => props.changePage('handlerreports.import') }/>
         <DesktopMenuItem text='desktop.sortsummaryreports' img="calendar-alt" clickMe={() => props.changePage('sortsummaryreports.import') }/>
         <DesktopMenuItem text='desktop.settings' img="cogs" clickMe={() => props.changePage('settings.collectionpoints') }/>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(DesktopMenu);
